import { graphql } from "react-relay";

export const RerunJobMutation = graphql`
  mutation RerunJobMutation($input: RerunJobInput!) {
    rerunJob(input: $input) {
      success
      jobRun {
        id
        status
      }
    }
  }
`;